import api from "../config/api";

// Anomali listesi
export const getAnomalies = async () => {
  try {
    const response = await api.get("/anomaly");
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Tek bir anomali getirme
export const getAnomalyById = async (id) => {
  try {
    const response = await api.get(`/anomaly/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Anomali durumu güncelleme
export const updateAnomalyStatus = async ({ id, hasAnomaly }) => {
  try {
    const response = await api.patch(`/anomaly/${id}/status`, { hasAnomaly });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Anomali seviyesi güncelleme
export const updateAnomalyLevel = async ({ id, anomalyLevel }) => {
  try {
    const response = await api.patch(`/anomaly/${id}/level`, { anomalyLevel });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Anomali silme
export const deleteAnomaly = async (id) => {
  try {
    const response = await api.delete(`/anomaly/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};
